import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import DataTable from 'components/spreadsheet/DataTable';
import { useTranslation } from 'react-i18next';

const SpreadsheetPreview = ({ src }) => {
    const { t } = useTranslation(); 
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        const readSpreadsheet = async () => {
            try {
                const arrayBuffer = await src.arrayBuffer();
                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

                if (jsonData.length > 0) {
                    const columnHeaders = Object.keys(jsonData[0]);
                    const cols = columnHeaders.map((header) => ({
                        Header: header,
                        accessor: header,
                    }));
                    setColumns(cols);
                    setData(jsonData);
                }
            } catch (error) {
                console.error('Error reading spreadsheet:', error);
            }
        };

        readSpreadsheet();
    }, [src]);

    if(!data || data.length === 0) return <p>{t('error.unsupportedMedia')}</p>;
    return <DataTable data={data} columns={columns}/>
};

export default SpreadsheetPreview;
